import { render, staticRenderFns } from "./usuarioContador.vue?vue&type=template&id=5a4c617a&scoped=true"
import script from "./usuarioContador.vue?vue&type=script&lang=js"
export * from "./usuarioContador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c617a",
  null
  
)

export default component.exports